export function transformIntegerInput(value?: number): string {
    if (!value) return '';
    return value.toString();
}
